import React, { useState } from 'react';
import { Button, Card, Form, Input, message } from 'antd';
import { useDispatch } from 'react-redux';
import { createProspect } from "../../Api/userApi";
import { updateUser } from "../../Api/userApi";


/**
 * Prospect Form component
 * @param prospect {Object, optional} - Prop for editing a prospect (leave empty for new prospect)
 * @param prospect.user_id {string} - Prospect ID
 * @param prospect.name {string} - Prospect name
 * @param prospect.email {string} - Prospect email
 * @param prospect.phone {string} - Prospect phone
 * @param prospect.portfolios {Array} - Array of portfolios
 *
 *
 *
 * @returns {JSX.Element}
 * @constructor
 */
const ProspectForm = ({ prospect }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  console.log('Prospect:', prospect)

  // Function to handle form submission
  const onFinish = async (values) => {
    let result;

    // Check if this is an existing prospect and update or create accordingly
    if (prospect) {
      const match = {
        uid: localStorage.getItem('uid'),
        'prospects.$.user_id': prospect.user_id
      }
      dispatch(updateUser({
        match: match,
        updateData: {
          $set: {
            'prospects.$.name': values.name,
            'prospects.$.email': values.email,
            'prospects.$.phone': values.phone,
          }
        }}
      ));
    } else {
      // For new prospects, portfolios might be handled differently
      result = await dispatch(createProspect({ ...values, portfolios: [] }));
    }

    // Handle the outcome of the dispatch call
    if (result?.payload) { // Adjust based on how your action creators are structured
      message.success(`Prospect ${prospect ? 'updated' : 'saved'} successfully.`);
      form.resetFields();
    } else {
      message.error(`An error occurred while ${prospect ? 'updating' : 'saving'} the prospect.`);
    }
  };

  return (
    <Card>
      <Form form={form} layout="vertical" onFinish={onFinish} initialValues={prospect || {portfolios: []}}>
        <Form.Item
          name="name"
          label="Name"
          rules={[{ required: true, message: 'Please input the prospect\'s name!' }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="email"
          label="Email"
          rules={[{ required: true, message: 'Please input the prospect\'s email!' }, { type: 'email', message: 'The input is not valid E-mail!' }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="phone"
          label="Phone (Optional)"
        >
          <Input />
        </Form.Item>
        {/* Assuming portfolios are managed elsewhere or added post-creation */}
        <Button type="primary" htmlType="submit">
          {prospect ? 'Update Prospect' : 'Create Prospect'}
        </Button>
      </Form>
    </Card>
  );
};

export default ProspectForm;
